module.exports = __webpack_public_path__ + "img/data.83ab0c31.svg";